import type { Visitor } from '../../api/types';

export const COMPANY_CURSOR_HEARTBEAT_MS = 100;
export const SOLO_CURSOR_HEARTBEAT_MS = 5000;

export function isSingleVisitor(visitors: Visitor[]): boolean {
  return visitors.length < 2;
}

export function cursorHeartbeatMs(visitors: Visitor[]): number {
  return isSingleVisitor(visitors)
    ? SOLO_CURSOR_HEARTBEAT_MS
    : COMPANY_CURSOR_HEARTBEAT_MS;
}
